export const DEACTIVATE_MODAL = {
  TITLE: 'Deactivate Rule?',
  DETAILS: 'Are you sure you want to deactivate the selected rule(s)?',
  WARNING: "Warning: You can't undo this action.",
  CANCEL_BUTTON: 'Cancel',
  DEACTIVATE_BUTTON: 'Deactivate',
};
